import React from 'react'
import { DialogDeleteInfra } from "./DialogDeleteInfra"
import { DialogAddInfra } from "./DialogAddInfra"
import { DialogEditInfra } from "./DialogEditInfra"
import { DialogAssociationInfra } from "./DialogAssociationInfra"
import { DialogInfraDetails } from "./DialogInfraDetails"
import { Box } from '@material-ui/core'



export function DialogAllInfrastructure(props) {

  function handleTypeOfDialog(typeDialog) {

    switch (typeDialog) {
      case 'add':
        return (
          <DialogAddInfra {...props} />
        )
      case 'delete':
        return (
          <DialogDeleteInfra {...props} />
        )
      case 'edit':
        return (
          <DialogEditInfra {...props} />
        )
      case 'association':
        return (
          <DialogAssociationInfra {...props} />
        )
      case 'detail':
        return (
          <DialogInfraDetails {...props} />
        )

      default:
        console.log(`Sorry, we are out of ${typeDialog}.`);
    }


  }
  return (
    <Box>
      {handleTypeOfDialog(props.typeDialog)}
    </Box>
  )
}
